(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9742],{

/***/ 18037:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M16.59 7.58 10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), 'CheckCircleOutline');

/***/ }),

/***/ 53592:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M14.59 8 12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'HighlightOff');

/***/ }),

/***/ 5616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Box_Box; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/@mui/styled-engine/index.js + 1 modules
var styled_engine = __webpack_require__(32485);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/styleFunctionSx.js
var styleFunctionSx = __webpack_require__(86523);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/extendSxProp.js
var extendSxProp = __webpack_require__(39707);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useTheme.js
var useTheme = __webpack_require__(96682);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/createBox.js
'use client';



const _excluded = ["className", "component"];






function createBox(options = {}) {
  const {
    themeId,
    defaultTheme,
    defaultClassName = 'MuiBox-root',
    generateClassName
  } = options;
  const BoxRoot = (0,styled_engine["default"])('div', {
    shouldForwardProp: prop => prop !== 'theme' && prop !== 'sx' && prop !== 'as'
  })(styleFunctionSx/* default */.Z);
  const Box = /*#__PURE__*/react.forwardRef(function Box(inProps, ref) {
    const theme = (0,useTheme/* default */.Z)(defaultTheme);
    const _extendSxProp = (0,extendSxProp/* default */.Z)(inProps),
      {
        className,
        component = 'div'
      } = _extendSxProp,
      other = (0,objectWithoutPropertiesLoose/* default */.Z)(_extendSxProp, _excluded);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(BoxRoot, (0,esm_extends/* default */.Z)({
      as: component,
      ref: ref,
      className: (0,clsx/* default */.Z)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
      theme: themeId ? theme[themeId] || theme : theme
    }, other));
  });
  return Box;
}
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/ClassNameGenerator/ClassNameGenerator.js
var ClassNameGenerator = __webpack_require__(37078);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTheme.js + 12 modules
var createTheme = __webpack_require__(549);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/identifier.js
var identifier = __webpack_require__(10606);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Box/boxClasses.js

const boxClasses = (0,generateUtilityClasses/* default */.Z)('MuiBox', ['root']);
/* harmony default export */ var Box_boxClasses = (boxClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Box/Box.js
'use client';







const defaultTheme = (0,createTheme/* default */.Z)();
const Box = createBox({
  themeId: identifier/* default */.Z,
  defaultTheme,
  defaultClassName: Box_boxClasses.root,
  generateClassName: ClassNameGenerator/* default.generate */.Z.generate
});
 false ? 0 : void 0;
/* harmony default export */ var Box_Box = (Box);

/***/ }),

/***/ 62804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ox": function() { return /* binding */ getCountries; },
  "IS": function() { return /* binding */ loginCallback; },
  "QO": function() { return /* binding */ userChangePassword; },
  "nu": function() { return /* binding */ userConfirmEmail; },
  "X1": function() { return /* binding */ userForgotPassword; },
  "cq": function() { return /* binding */ userGetProfile; },
  "Kv": function() { return /* binding */ userLogout; },
  "lf": function() { return /* binding */ userResendConfirmEmail; },
  "Fw": function() { return /* binding */ userRestorePassword; },
  "ii": function() { return /* binding */ userSignIn; },
  "EQ": function() { return /* binding */ userSignUp; },
  "lP": function() { return /* binding */ userUpdateProfile; }
});

// EXTERNAL MODULE: ./api/base-services.request.ts + 1 modules
var base_services_request = __webpack_require__(11882);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./shared/models/endpoits/clients/clients.endpoints.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ClientsStatic;

(function (ClientsStatic) {
  ClientsStatic["register"] = "/v2/clients/sign-up";
  ClientsStatic["login"] = "/v2/clients/login";
  ClientsStatic["logout"] = "/v2/clients/logout";
  ClientsStatic["forgotPassword"] = "/v2/clients/send-forgot-pasword";
  ClientsStatic["changePassword"] = "/v2/clients/change-password";
  ClientsStatic["confirmEmail"] = "/v2/clients/confirm-email";
  ClientsStatic["resendConfirmEmail"] = "/v2/clients/resend-confirm-email";
  ClientsStatic["profile"] = "/v2/clients";
  ClientsStatic["updateProfile"] = "/v2/clients/edit?_method=PUT";
  ClientsStatic["countries"] = "/v2/clients/countries";
})(ClientsStatic || (ClientsStatic = {}));

var ClientsDynamic = {
  /**
   * @member {string}
   * @method POST
   * @version 2.0
   * @description Send new password.
   */
  resetPassword: function resetPassword(userId) {
    return "/v2/clients/reset-password/" + userId;
  },

  /**
   * @member {string}
   * @method GET
   * @version 2.0
   * @description Send search params to callback for OAuth.
   */
  loginCallback: function loginCallback(provider) {
    return "/v2/clients/login/".concat(provider, "/callback");
  }
};
var ClientsEndpoints = _objectSpread(_objectSpread({}, ClientsDynamic), ClientsStatic);
;// CONCATENATED MODULE: ./api/clients/clients.request.ts


function userSignUp(body) {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.register, body).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data;
  });
}
function userSignIn(body) {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.login, body).then(function (_ref) {
    var data = _ref.data;
    return data.data;
  });
}
function userLogout() {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.logout, null).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data;
  });
}
function userForgotPassword(body) {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.forgotPassword, body).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data;
  });
}
function userRestorePassword(clientId, searchParams, body) {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.resetPassword(clientId) + searchParams, body).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data;
  });
}
function userChangePassword(body) {
  return (0,base_services_request/* patchResquest */.Ft)(ClientsEndpoints.changePassword, body).then(function (_ref2) {
    var data = _ref2.data;
    return data;
  });
}
function userConfirmEmail(body) {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.confirmEmail, body).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data;
  });
}
function userResendConfirmEmail(body) {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.resendConfirmEmail, body).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data;
  });
}
function loginCallback(provider, searchParams) {
  return (0,base_services_request/* getRequest */.A_)(ClientsEndpoints.loginCallback(provider) + searchParams).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data.data;
  });
}
function userUpdateProfile(body) {
  var useMultipartFormData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.updateProfile, body, useMultipartFormData).then(function (_ref3) {
    var data = _ref3.data;
    return data.data;
  });
}
function userGetProfile() {
  return (0,base_services_request/* getRequest */.A_)(ClientsEndpoints.profile).then(function (_ref4) {
    var data = _ref4.data;
    return data.data;
  });
}
function getCountries() {
  return (0,base_services_request/* getRequest */.A_)(ClientsEndpoints.countries).then(function (_ref5) {
    var data = _ref5.data;
    return data.data;
  });
}

/***/ }),

/***/ 99109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useAppSelector; },
/* harmony export */   "T": function() { return /* binding */ useAppDispatch; }
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9473);

// Use throughout your app instead of plain `useDispatch` and `useSelector`
var useAppDispatch = react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0;
var useAppSelector = react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9;

/***/ }),

/***/ 57207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ LoginPage; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_forgot_password_form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44959);
/* harmony import */ var shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1283);
/* harmony import */ var custom_hooks_redux_hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99109);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70917);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var __N_SSP = true;
function LoginPage(props) {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
  var titleT = (0,next_intl__WEBPACK_IMPORTED_MODULE_7__.useTranslations)("title-pages");
  var user = (0,custom_hooks_redux_hooks__WEBPACK_IMPORTED_MODULE_6__/* .useAppSelector */ .C)(function (state) {
    return state.Auth.user;
  });

  function onSuccess() {
    router.push(shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_5__/* .CPagesPath.es.home */ .K.es.home);
  }

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (user) router.push(shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_5__/* .CPagesPath.es.profile */ .K.es.profile);
  });
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("title", null, titleT("forgot-password"))), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(Center, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(Content, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_components_forgot_password_form__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    onClose: onSuccess
  }))));
}

var Center = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "er4q7zo1"
} : 0)( true ? {
  name: "3q2q71",
  styles: "display:grid;place-content:center;height:var(--main-height);padding:20px"
} : 0);

var Content = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "er4q7zo0"
} : 0)( true ? {
  name: "12u3f4i",
  styles: "background-color:white;max-width:600px;padding:70px 20px 20px;border-radius:40px;box-shadow:0px 4px 12px rgba(0, 0, 0, 0.13)"
} : 0);

/***/ }),

/***/ 44959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ForgotPasswordForm; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86886);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82580);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _text_field__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22900);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66621);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74231);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48228);
/* harmony import */ var api_clients_clients_request__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62804);
/* harmony import */ var _message_modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36481);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70917);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var initialValues1 = {
  email: "",
  "g-recaptcha-response": ""
};
function ForgotPasswordForm(props) {
  var onClose = props.onClose;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      showMessage = _useState[0],
      setShowMessage = _useState[1];

  var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_8__.useTranslations)("restorePasswordForm");
  var tErrors = (0,next_intl__WEBPACK_IMPORTED_MODULE_8__.useTranslations)("error");
  var validationSchema = yup__WEBPACK_IMPORTED_MODULE_5__/* .object */ .Ry({
    email: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().email(tErrors("email")).required(tErrors("required")) // "g-recaptcha-response": yup.string().required(tErrors("captcha")),

  });

  var _useMutation = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_9__/* .useMutation */ .D)(api_clients_clients_request__WEBPACK_IMPORTED_MODULE_6__/* .userForgotPassword */ .X1, {
    onSuccess: function onSuccess() {
      return setShowMessage(true);
    },
    onError: console.log //?

  }),
      mutateAsync = _useMutation.mutateAsync,
      isLoading = _useMutation.isLoading;

  function onSuccessClose() {
    setShowMessage(false);
    if (onClose) onClose();
  }

  var onSubmit = function onSubmit(values) {
    return mutateAsync(values);
  };

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
    container: true,
    mb: 5
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
    item: true,
    xs: 12,
    sm: 9,
    textAlign: "center",
    margin: "auto"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("h3", {
    css: styles.title
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(BoldTitle, null, t("header.title-left")), "\xA0", (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(ThinTitle, null, t("header.title-right"))))), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(formik__WEBPACK_IMPORTED_MODULE_1__/* .Formik */ .J9, {
    initialValues: initialValues1,
    validationSchema: validationSchema,
    onSubmit: onSubmit,
    enableReinitialize: true
  }, function (formikProps) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(formik__WEBPACK_IMPORTED_MODULE_1__/* .Form */ .l0, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
      container: true,
      spacing: 2
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
      item: true,
      xs: 12,
      sm: 8,
      margin: "auto"
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_text_field__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      name: "email",
      label: t("field.email")
    })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
      item: true,
      xs: 12,
      textAlign: "center",
      mb: 2
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      type: "submit",
      fs: "12px",
      bg: "--color-brand-red-main",
      thin_button: true,
      disabled: isLoading,
      loadingMessage: isLoading ? t("sending") : null
    }, t("submitBtn")))));
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_message_modal__WEBPACK_IMPORTED_MODULE_7__/* .ModalMessage */ .P, {
    title: t("successMsg.title"),
    body: t("successMsg.content"),
    open: showMessage,
    handleClose: onSuccessClose
  }));
}

var BoldTitle = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "e1yhrbee1"
} : 0)( true ? {
  name: "15p8j2o",
  styles: "font-weight:700;text-transform:uppercase"
} : 0);

var ThinTitle = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "e1yhrbee0"
} : 0)( true ? {
  name: "148c1u2",
  styles: "font-weight:300;text-transform:uppercase"
} : 0);

var styles = {
  title: {
    marginBottom: 21
  }
};

/***/ }),

/***/ 78836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70917);
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var LabelField = function LabelField(props) {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span", {
    css: styles.label,
    className: "label-customs ".concat(props.positionLabel)
  }, props.label);
};

/* harmony default export */ __webpack_exports__["Z"] = (LabelField);
var styles = {
  label:  true ? {
    name: "8knltz",
    styles: "width:100%;display:block;padding-left:10px;font-size:0.9375rem;font-weight:600;line-height:21px;color:var(--color-brand-blue-main);vertical-align:bottom !important;margin-bottom:10px;&.center{text-align:center;}&.left:{text-align:left;}&.right:{text-align:right;}"
  } : 0
};

/***/ }),

/***/ 22900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* reexport */ default_text_field; },
  "Z": function() { return /* reexport */ formik_text_field; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(36864);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./node_modules/@mui/material/Input/Input.js
var Input = __webpack_require__(79332);
// EXTERNAL MODULE: ./shared/components/label-field/index.tsx
var label_field = __webpack_require__(78836);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/text-field/default-text-field.tsx




var _excluded = ["label", "value", "errorsComponents"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







function DefaultTextField(props) {
  var label = props.label,
      value = props.value,
      errorsComponents = props.errorsComponents,
      res = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  var onChange = function onChange(e) {
    if (props !== null && props !== void 0 && props.onChange) {
      props.onChange(e);
    }
  };

  var config = _objectSpread(_objectSpread(_objectSpread({}, res), {
    id: props.name
  }), {}, {
    onChange: onChange
  });

  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    css: styles.contentInput,
    className: "content-input-field"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(label_field/* default */.Z, {
    label: label,
    positionLabel: props.positionLabel
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(Input/* default */.Z, (0,esm_extends/* default */.Z)({
    label: undefined,
    css: styles.inputField,
    disableUnderline: true
  }, config, {
    value: value
  })), errorsComponents && /*#__PURE__*/react.cloneElement(errorsComponents));
}

/* harmony default export */ var default_text_field = (DefaultTextField);
var styles = {
  inputField:  true ? {
    name: "n2fz1z",
    styles: "width:100%;outline:none;border:1px solid var(--color-brand-border);border-radius:50px;padding:8px 23px;background:none;color:var(--color-brand-blue-main);font-family:var(--font-family);font-style:normal;font-weight:700;font-size:var( --fs-body-small);line-height:21px;& input::placeholder{color:var(--color-brand-blue-main);opacity:1;}&:hover{border:1px solid var(--color-brand-blue-collection-main);}"
  } : 0,
  contentInput:  true ? {
    name: "1d3w5wq",
    styles: "width:100%"
  } : 0,
  inputErrors:  true ? {
    name: "1sc7l0d",
    styles: "width:100%;color:var(--color-brand-red-secondary);font-weight:500;padding-left:10px;font-size:0.8125rem;display:flex;align-items:center;& .iconError{font-size:0.8125rem;margin-right:3px;}"
  } : 0
};

var Errors = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("span",  true ? {
  target: "eq6sl9n0"
} : 0)( true ? "" : 0)));
;// CONCATENATED MODULE: ./shared/components/text-field/formik-text-field.tsx



var formik_text_field_excluded = ["name", "onChange"];

function formik_text_field_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function formik_text_field_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? formik_text_field_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : formik_text_field_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function formik_text_field_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







function FormikTextField(props) {
  var _useField = (0,formik_esm/* useField */.U$)(props),
      _useField2 = (0,slicedToArray/* default */.Z)(_useField, 3),
      field = _useField2[0],
      meta = _useField2[1],
      helpers = _useField2[2];

  var name = props.name,
      onChange = props.onChange,
      res = (0,objectWithoutProperties/* default */.Z)(props, formik_text_field_excluded);

  var handleChange = function handleChange(value) {
    if (value.target) {
      field.onChange(value);
    } else {
      helpers.setValue(value);
    }
  };

  var config = formik_text_field_objectSpread(formik_text_field_objectSpread(formik_text_field_objectSpread(formik_text_field_objectSpread({}, field), res), {
    id: name
  }), {}, {
    onChange: props.onChange || handleChange,
    errorsComponents: ErrorsComponents({
      meta: meta
    })
  });

  return (0,emotion_react_browser_esm/* jsx */.tZ)(default_text_field, config);
}

/* harmony default export */ var formik_text_field = (FormikTextField);

var ErrorsComponents = function ErrorsComponents(_ref) {
  var meta = _ref.meta;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, meta.error && meta.touched && (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    css: formik_text_field_styles.inputErrors
  }, meta.error));
};

var formik_text_field_styles = {
  inputField:  true ? {
    name: "n2fz1z",
    styles: "width:100%;outline:none;border:1px solid var(--color-brand-border);border-radius:50px;padding:8px 23px;background:none;color:var(--color-brand-blue-main);font-family:var(--font-family);font-style:normal;font-weight:700;font-size:var( --fs-body-small);line-height:21px;& input::placeholder{color:var(--color-brand-blue-main);opacity:1;}&:hover{border:1px solid var(--color-brand-blue-collection-main);}"
  } : 0,
  contentInput:  true ? {
    name: "1d3w5wq",
    styles: "width:100%"
  } : 0,
  inputErrors:  true ? {
    name: "1sc7l0d",
    styles: "width:100%;color:var(--color-brand-red-secondary);font-weight:500;padding-left:10px;font-size:0.8125rem;display:flex;align-items:center;& .iconError{font-size:0.8125rem;margin-right:3px;}"
  } : 0
};
;// CONCATENATED MODULE: ./shared/components/text-field/index.tsx




/***/ }),

/***/ 1283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ CPagesPath; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var UniversalLinks = {
  blog: "https://blog.remaxrd.com/"
};
var es = {
  home: "/",
  collection: "/collection",
  collection_properties: "/collection/propiedades",
  collection_agents_list: "/collection/agentes",
  collection_property_detail: function collection_property_detail(x) {
    return "/collection/propiedad/".concat(RealestateEncode(x.realstate_type), "/").concat(x.slug);
  },
  collection_agent_detail: function collection_agent_detail(x) {
    return "/collection/agente/".concat(HEncodeString(x.name), "/").concat(x.id);
  },
  properties: "/propiedades",
  shop: "/propiedades/comprar",
  acquire: "/propiedades/alquilar",
  property_detail: function property_detail(x) {
    return "/propiedad/".concat(RealestateEncode(x.realstate_type), "/").concat(x === null || x === void 0 ? void 0 : x.slug);
  },
  project: "/proyectos",
  project_Detail: function project_Detail(x) {
    return "/proyecto/".concat(x.slug);
  },
  loan_form: "/prestamos/formulario",
  loan_mortgage: "/prestamos/hipotecarios",
  loan_calculator: "/prestamos/calculadora",
  franchises: "/franquicias",
  agents_list: "/listado/agentes",
  agent_detail: function agent_detail(x) {
    return "/agente/".concat(HEncodeString(x.name), "/").concat(x.id);
  },
  agencies_list: "/listado/agencias",
  agency_detail: function agency_detail(x) {
    return "/agencia/".concat(HEncodeString(x.name), "/").concat(x.id);
  },
  frequent_questions: "/preguntas-frecuentes",
  join: "/agentes",
  termsAndCondition: "/terminos-condiciones",
  privacyPolitics: "/politica-privacidad",
  signin: "/acceder",
  profile: "/perfil",
  profileEditar: "/perfil/configuracion/editar-perfil",
  profileCambiarClave: "/perfil/configuracion/cambiar-clave",
  profileFavorites: "/perfil/configuracion/favoritos",
  ProfileSearchHistory: "/perfil/configuracion/busquedas",
  ProfileLastedSee: "/perfil/configuracion/historial-busquedas",
  signup: "/registrate",
  forgotPassword: "/restaurar-clave"
};
var CPagesPath = _objectSpread(_objectSpread({}, UniversalLinks), {}, {
  es: es
});

var HEncodeString = function HEncodeString(x) {
  return "".concat(x.replace(/\//g, "-").split(" ").join("-").toLowerCase());
};

var RealestateEncode = function RealestateEncode(x) {
  var _x$replaceAll;

  return x === null || x === void 0 ? void 0 : (_x$replaceAll = x.replaceAll("/", "o")) === null || _x$replaceAll === void 0 ? void 0 : _x$replaceAll.replaceAll(" ", "-").toLowerCase();
};

/***/ }),

/***/ 64923:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgot-password",
      function () {
        return __webpack_require__(57207);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14666:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),

/***/ 14882:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2708,1629,8407,2615,6877,4022,70,3843,7918,9043,8543,2960,7956,4864,3282,2888,179], function() { return __webpack_exec__(64923); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);